import React from "react";
import { PageHero, CTA } from "@/components/PageHero";
import { COMPANIES } from "@/data/site";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";

export default function Companies() {
  useSEO({
    title: "Our Companies — The Easyworks Family",
    description: "Six specialised companies under Easyworks Industries: Digital, Software, AI, Cloud, Creative and Marketing — each an expert in their domain.",
  });
  return (
    <div data-testid="companies-page">
      <PageHero title="Our Companies" subtitle="Six specialised companies under one roof — each an expert in their domain, all working together for your business." />
      <section className="py-20">
        <div className="container mx-auto max-w-7xl px-6 space-y-8">
          {COMPANIES.map((c, i) => {
            const Icon = c.icon;
            const flip = i % 2 === 1;
            return (
              <div key={c.key} id={c.key} className={`grid lg:grid-cols-2 gap-8 items-center p-8 rounded-2xl bg-white border border-slate-200 ${flip ? "lg:flex-row-reverse" : ""}`} data-testid={`company-detail-${c.key}`}>
                <div className={flip ? "lg:order-2" : ""}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${c.color} flex items-center justify-center`}>
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <div className="text-[11px] tracking-[0.2em] font-semibold text-[#2563EB] uppercase">{c.tag}</div>
                      <div className="text-2xl font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>{c.name}</div>
                    </div>
                  </div>
                  <p className="text-slate-600 leading-relaxed mb-4">{c.description}</p>
                  <ul className="space-y-2 text-[14px] text-slate-600 mb-6">
                    <li>• Domain-focused expertise and dedicated team</li>
                    <li>• Proven delivery processes and quality standards</li>
                    <li>• Seamless integration with other Easyworks companies</li>
                  </ul>
                  <Link to="/contact" className="inline-flex items-center gap-1.5 text-[14px] font-semibold text-[#2563EB] hover:text-[#1D4ED8]">
                    Get in touch <ArrowRight className="w-3.5 h-3.5" />
                  </Link>
                </div>
                <div className={`${flip ? "lg:order-1" : ""} rounded-xl bg-gradient-to-br from-slate-50 to-blue-50/50 border border-slate-100 p-10 flex items-center justify-center min-h-[240px]`}>
                  <div className={`w-32 h-32 rounded-2xl bg-gradient-to-br ${c.color} flex items-center justify-center shadow-2xl shadow-blue-500/20 float-slow`}>
                    <Icon className="w-14 h-14 text-white" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <CTA />
    </div>
  );
}
